import React, { useState, useEffect } from "react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import {
  Table,
  Select,
  Loader,
  Button
} from "semantic-ui-react";
import { Container, Content, Center, Text } from './styled'
import { pb4y as api, pb4yLocal as local } from "../../../../services/apis";
import { datePattern } from '../../../../utils/Utils';
import { Box } from "@material-ui/core";

const options = [
  { key: 'BR', value: 'BR', text: 'Português' },
  { key: 'EN', value: 'EN', text: 'Inglês' },
  { key: 'ES', value: 'ES', text: 'Espanhol' },
  { key: 'DE', value: 'DE', text: 'Alemão' },
  { key: 'RU', value: 'RU', text: 'Russo' },
  { key: 'ZH', value: 'ZH', text: 'Chinês' },
  { key: 'FR', value: 'FR', text: 'Francês' },
  { key: 'IT', value: 'IT', text: 'Italiano' }
]

function BookRecommendations() {
  const [books, setBooks] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [lang, setLang] = useState('');

  useEffect(() => {
    async function getDate() {
      setLoading(true)
      const langFilter = lang ? `&lang=${lang}` : '';

      await api.get(`user-recommendations?${langFilter}`, lang).then(res => {
        setBooks(res.data);
        setTotalItems(res.data.length)
        setLoading(false)
      }).catch(err => {
        setLoading(false)
        console.error(err);
      })
    }
    getDate()
  }, [lang])

  return (
    <Box width="100%" paddingLeft="250px">
    <Box width="100%" padding="1rem">
      <AdminMenu />
        <Content>
          <h1>Livros Recomendados</h1>
          <Center space>
            <h3>Total: {totalItems}</h3>
            <div>
              <Select placeholder='Selecionar idioma' value={lang.text} options={options}
                onChange={(e, data) => setLang(data.value)} />
              <Button primary onClick={() => setLang('') }>Limpar</Button>
            </div>
          </Center>

          <Table stackable>
            <Table.Header>
              <Table.HeaderCell style={{ width: "5%" }}>
                <Center>ID</Center>
              </Table.HeaderCell>
              <Table.HeaderCell style={{ width: "15%" }}>
                <Center>ID Usuário</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>E-mail</Center>
              </Table.HeaderCell>
              <Table.HeaderCell style={{ width: '40%' }} >
                <Center>Nome do Livro</Center >
              </Table.HeaderCell>
              <Table.HeaderCell style={{ width: '15%' }}>
                <Center>Nome do autor</Center >
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Data</Center>
              </Table.HeaderCell>
              <Table.HeaderCell style={{ width: "5%" }}>
                <Center>Linguagem</Center>
              </Table.HeaderCell>
            </Table.Header>

            {loading ? <Loader active={loading} /> :
              books.length !== 0 ? books.map(user => {

                return (
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell style={{ width: "5%" }}>
                        <Center>{user.id}</Center>
                      </Table.Cell>
                      <Table.Cell style={{ width: "15%" }}>
                        <Center>{user.id_user}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{user.email}</Center>
                      </Table.Cell>
                      <Table.Cell style={{ width: '40%' }}>
                        <Center>{user.name_book}</Center>
                      </Table.Cell>
                      <Table.Cell style={{ width: '15%' }} >
                        <Center>{user.name_author}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{datePattern(user.data_create)}</Center>
                      </Table.Cell>
                      <Table.Cell style={{ width: "5%" }}>
                        <Center>{user.language}</Center>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>)
              }) : <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan='7'>
                    <Text>Nenhuma recomendação encontrada</Text>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>}
          </Table>
        </Content>
      </Box>
    </Box>
  )
}

export default BookRecommendations;
